import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Footer from "../../layouts/footer/Footer";
import ShopMain from "../../layouts/main/ShopMain";
import PRODUCT_CHUNK, { DEFAULT_LANGUAGE } from "../../utils/global_const";
import { useParams } from "react-router-dom";
import { ProductContext } from "../../context/ProductContext";
import Header from "../../layouts/header/Header";
import BestSellerMain from "../../layouts/main/product/BestSellerMain";

const SEOConfig = {
  en: {
    title: "Best Sellers | Wholesale Nicotine Pouches – B2B SnusCo",
    description:
      "Stock your tobacco shop with our top-selling nicotine pouches, trusted by retailers across Europe for their consistent quality, rich flavors, and reliable nicotine content. Order in bulk now with B2B SnusCo!",
    keywords:
      "snusco, b2b snusco, wholesale best sellers, bulk nicotine pouches, tobacco shop supplies, nicotine pouches Europe",
    url: "https://b2b.snusco.at/en/best-sellers",
    images: ["https://b2b.snusco.at/assets/bestseller-category-image.jpg"],
  },
  de: {
    title: "Bestseller | Großhandel Nikotintaschen – B2B SnusCo GmbH",
    description:
      "Statten Sie Ihr Tabakgeschäft mit unseren meistverkauften Nikotintaschen aus, geschätzt von Händlern in ganz Europa für gleichbleibende Qualität, intensive Aromen und verlässlichen Nikotingehalt. Jetzt in großen Mengen bei B2B SnusCo bestellen!",
    keywords:
      "snusco, b2b snusco, Bestseller Großhandel, Bulk Nikotintaschen, Tabakladenbedarf, Nikotintaschen Europa",
    url: "https://b2b.snusco.at/de/bestseller",
    images: ["https://b2b.snusco.at/assets/bestseller-category-image.jpg"],
  },
};

const BestSeller = () => {
  const { t, i18n } = useTranslation();
  const { loadFeaturedProducts } = useContext(ProductContext);

  const [initialLoad, setInitialLoad] = useState(false);

  useEffect(() => {
    if (!initialLoad) {
      // Proverava da li je ovo prvi put da se učitava
      loadFeaturedProducts();
      setInitialLoad(true); // Postavlja da je inicijalno učitavanje završeno
    }
  }, [initialLoad]);

  const [seo, setSeo] = useState(SEOConfig[DEFAULT_LANGUAGE]);

  useEffect(() => {
    setSeo(SEOConfig[i18n.language] || SEOConfig[DEFAULT_LANGUAGE]);
  }, [i18n.language]);

  return (
    <div>
      <Helmet>
        <html lang={i18n.language} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.url} />

        {/* Open Graph slike - Primarna slika na prvom mestu */}
        {seo.images?.map((image, index) => (
          <meta key={index} property="og:image" content={image} />
        ))}

        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="author" content="SnusCo" />
        <link rel="canonical" href={seo.url} />
      </Helmet>
      <Header />
      <BestSellerMain />
      <Footer />
    </div>
  );
};

export default BestSeller;
